module.exports = __webpack_public_path__ + "img/authorizedSignature.a6de226e.svg";